import { Component } from '@angular/core';
import { FormArray, FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import {
	ButtonComponent,
	ButtonIconComponent,
	DividerComponent,
	EmptyStateComponent,
	FormGroupComponent,
	ITab,
	InputComponent,
	ItemComponent,
	ListDetailComponent,
	MenuComponent,
	SwitchComponent,
	TabsComponent,
	TagComponent,
	TileComponent,
} from '@tecalisdev/infinity';
import { OPERATION_TYPE } from '../../../../operations/models/operations.models';
import { WorkflowFormOperationPanelBase } from './workflow-form-operation-panel.base';
import { WorkflowFormAdvancedCollapseComponent } from '../workflow-form-advanced-collapse.component';

/**
 * Panel UI de DOCUMENTS en el editor (NIF-530).
 * Abrir cuando: filas de docs, título custom o tutorial.
 */
@Component({
	selector: 'app-workflow-form-documents-panel',
	imports: [
		WorkflowFormAdvancedCollapseComponent,
		ReactiveFormsModule,
		TranslatePipe,
		TileComponent,
		ItemComponent,
		TagComponent,
		EmptyStateComponent,
		ButtonComponent,
		ButtonIconComponent,
		MenuComponent,
		FormGroupComponent,
		SwitchComponent,
		TabsComponent,
		InputComponent,
		ListDetailComponent,
		DividerComponent,
	],
	templateUrl: './workflow-form-documents-panel.component.html',
})
export class WorkflowFormDocumentsPanelComponent extends WorkflowFormOperationPanelBase {
	protected readonly operationType = OPERATION_TYPE.DOCUMENTS;

	public get documentsArray(): FormArray {
		return this.host.documentsArray;
	}

	public get workflowLocaleTabs(): ITab[] {
		return this.host.workflowLocaleTabs;
	}

	public get selectedWorkflowLocaleId(): string {
		return this.host.selectedWorkflowLocaleId;
	}

	public get expandDocumentsAdvancedForLocaleScroll(): boolean {
		return this.host.expandDocumentsAdvancedForLocaleScroll;
	}

	public get hasCustomTitle(): boolean {
		return this.readBool('custom_title');
	}

	public getWorkflowLocaleControl(...segments: string[]): FormControl {
		return this.host.getWorkflowLocaleControl(...segments);
	}

	public onWorkflowLocaleTabSelected(tab: ITab): void {
		this.host.onWorkflowLocaleTabSelected(tab);
	}

	public newDoc(): void {
		this.host.newDoc();
	}

	public documentsMenuChange(event: unknown, index: number): void {
		this.host.documentsMenuChange(event, index);
	}

	public resolveDocRowTitle(value: unknown): string {
		return this.host.resolveDocRowTitle(value);
	}
}
